(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/footer/toggle-customer.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/footer/toggle-customer.js');

'use strict';

const {
  useAtom
} = jotai;
const {
  isNewCustomerAtom
} = svs.iam_idp.atoms;
const {
  Button
} = svs.ui;
const ToggleCustomer = () => {
  const [isNewCustomer, setIsNewCustomer] = useAtom(isNewCustomerAtom);
  return React.createElement("div", {
    className: "footer-btns"
  }, React.createElement(Button, {
    className: "toggle-button",
    onClick: () => setIsNewCustomer(!isNewCustomer),
    transparent: true
  }, isNewCustomer ? 'Redan kund?' : 'Bli kund?'));
};
svs.iam_idp.components.footer.ToggleCustomer = ToggleCustomer;

 })(window);